import React from "react";
import { Edit } from "@refinedev/antd";
import { useCustom, useCustomMutation } from "@refinedev/core";
import { message, Form } from "antd";
import {
  UPDATE_RECEIVING_MUTATION,
  RECEIVING_BY_ID_QUERY,
} from "./queries";
import { Receiving, ReceivingStatus, UpdateReceivingInput } from "./interface";
import { useParams } from "react-router-dom";
import { ReceivingForm } from "./components/ReceivingForm";

export const EditReceiving: React.FC = () => {
  const params = useParams();
  const id = params?.id as string;

  const [form] = Form.useForm();

  // Fetch receiving data
  const { data, isLoading, refetch } = useCustom<any>({
    url: "",
    method: "post",
    meta: {
      gqlQuery: RECEIVING_BY_ID_QUERY,
      variables: { id },
    },
    queryOptions: { enabled: !!id },
  });

  const record: Receiving | undefined = (data as any)?.data?.receiving ?? (data as any)?.data ?? undefined;

  // Update receiving
  const { mutate: updateMutate, isLoading: updating } = useCustomMutation();

  const handleSaveDraft = async (values: UpdateReceivingInput) => {
    console.log(values)
    if (!id) return;

    // Get current receiving status to determine appropriate draft status
    const currentStatus = record?.status;

    // If current status is RECEIVED, set to DRAFT_ACCEPTANCE for draft saving
    // Otherwise, preserve the original status
    const draftStatus = currentStatus === ReceivingStatus.RECEIVED
      ? ReceivingStatus.DRAFT_ACCEPTANCE
      : currentStatus;

    updateMutate(
      {
        url: "",
        method: "post",
        values: {
          id,
          input: {
            ...values,
            status: draftStatus,
          },
        },
        meta: { gqlMutation: UPDATE_RECEIVING_MUTATION },
      },
      {
        onSuccess: () => {
          message.success("Receiving saved as draft successfully");
          refetch();
        },
        onError: (e) => {
          console.error(e);
          message.error("Failed to save receiving draft");
        },
      },
    );
  };

  const handleSubmit = async (values: UpdateReceivingInput) => {
    if (!id) return;
    updateMutate(
      {
        url: "",
        method: "post",
        values: {
          id,
          input: values,
        },
        meta: { gqlMutation: UPDATE_RECEIVING_MUTATION },
      },
      {
        onSuccess: () => {
          message.success("Receiving updated successfully");
          refetch();
        },
        onError: (e) => {
          console.error(e);
          message.error("Failed to update receiving");
        },
      },
    );
  };

  return (
    <Edit
      title="Edit Receiving"
      isLoading={isLoading}
      saveButtonProps={{ loading: updating, style: { display: "none" } }}
      footerButtons={() => null}
    >
      <ReceivingForm
        form={form}
        initialValues={record}
        isEdit={true}
        onSaveDraft={handleSaveDraft}
        onSubmit={handleSubmit}
        mode="edit"
      />
    </Edit>
  );
};